import { post } from '@namespace/helpers';

export const getCrmWagerBonuses = () =>
  post('/service/crm_proxy/crm_api/gamegate/anybonus/wagering');
